import React, { PureComponent } from "react";
import * as config from "../config";

export default class LoadingContent extends PureComponent {
    static propTypes = {};

    render() {
        return (
            <div className="container">
                <img
                    alt="Loading"
                    className="center-block img-responsive centered"                        
                    src={`${config.rootUrl}/images/aanp_spinner.gif`}
                />
            </div>
        );
    }
}